import versionData from '../../build.json';

const baseApiUrl = process.env.BASE_API_URL;

const urls = () => {
  return {
    baseApiUrl: baseApiUrl,
    // login
    loginUrl: `${baseApiUrl}/api/login_check`,

    // trees
    treePublicGeoJsonListUrl: `${baseApiUrl}/api/public/geojsonlist`,
    treeListUrl: `${baseApiUrl}/api/tree/list`,
    treeUrl: `${baseApiUrl}/api/tree`,
    treePublicUrl: `${baseApiUrl}/api/public/tree`,
    treeCreateUrl: `${baseApiUrl}/api/tree/create`,
    treeCountUrl: `${baseApiUrl}/api/tree/count`,
    treeDeleteUrl: `${baseApiUrl}/api/tree/delete`,
    treeCertifyUrl: `${baseApiUrl}/api/tree/certify`,
    treeValidationUrl: `${baseApiUrl}/api/tree`,
    treeValidationHistoryUrl: `${baseApiUrl}/api/tree/validation-history`,
    treeGeoJsonListUrl: `${baseApiUrl}/api/tree/geojsonlist`,
    treeGeoJsonFileUrl: `${baseApiUrl}/api/tree/geojsonfile`,
    treeMoveUrl: `${baseApiUrl}/api/tree/move`,
    downloadkml: `${baseApiUrl}/api/tree/download/kml`,
    treePublicGeoJsonFileUrl: `${baseApiUrl}/api/public/geojsonfile?nb=2`,
    highlightedCountriesUrl: `${baseApiUrl}/api/public/count-by-country`,

    // tree types
    treeTypeListUrl: `${baseApiUrl}/api/treetype/list`,

    // contract
    getContractUrl: `${baseApiUrl}/api/contract`,
    contractListUrl: `${baseApiUrl}/api/contract/list`,

    // photo
    setPhotoComment: `${baseApiUrl}/api/photo/comment`,

    // user
    getUserInfosUrl: `${baseApiUrl}/api/user/get`,
    getMyUserInfosUrl: `${baseApiUrl}/api/user/me`,
    userListUrl: `${baseApiUrl}/api/user/list`,
    resetPasswordUrl: `${baseApiUrl}/reset-password`,
    resetPasswordNewPasswordUrl: `${baseApiUrl}/reset`,

    // user admin
    adminUserListUrl: `${baseApiUrl}/api/user/admin/list`,
    updateUserInfosUrl: `${baseApiUrl}/api/user/admin/update`,

    // contract admin
    createUserUrl: `${baseApiUrl}/api/user/admin/create`,
    contractAdminListUrl: `${baseApiUrl}/api/contract/admin/list`,
    getContractAdminUrl: `${baseApiUrl}/api/contract/admin/get`,
    findContractUrl: `${baseApiUrl}/api/admin/contract/find`,
    addUserToContract: `${baseApiUrl}/api/contract/admin/addUser`,
    removeUserFromContract: `${baseApiUrl}/api/contract/admin/removeUser`,
    createContractUrl: `${baseApiUrl}/api/contract/admin/create`,
    updateContractUrl: `${baseApiUrl}/api/contract/admin/update`,

    // impersonation
    stopImpersonationUrl: `${baseApiUrl}/api/impersonation/stop`,
  };
}

function isCurrentVersionInstalled() {
  const current = getCurrentVersion();
  const targetVersion = (versionData as any)?.version;
  // If no version is defined in build.json, consider any stored value as installed
  if (!targetVersion) {
    return !!current;
  }
  return current === targetVersion;
}

function getCurrentVersion() {
  return localStorage.getItem('version');
}

function setCurrentVersion() {
  const targetVersion = (versionData as any)?.version || 'installed';
  localStorage.setItem('version', String(targetVersion));
}

export default {
  urls,
  isCurrentVersionInstalled,
  getCurrentVersion,
  setCurrentVersion
}
